import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { Logo } from "../components/joe/Badges";
import { api, store, errMsg } from "../lib/api";

export const homeFor = (role) => ({ admin: "/office", specialist: "/office/leads", partner: "/partner", homeowner: "/case" }[role] || "/");

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password: pw });
      store.token = data.token;
      if (data.user.role === "homeowner") store.caseToken = null;
      nav(homeFor(data.user.role));
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <div className="grain grid min-h-screen place-items-center px-5">
      <form onSubmit={go} className="rise relative z-10 w-full max-w-sm rounded-3xl border border-slate-200 bg-white p-7 shadow-sm" data-testid="login-form">
        <Logo />
        <h1 className="mt-6 text-2xl font-bold">Sign in</h1>
        <p className="mt-1 text-sm text-slate-600">Homeowners, specialists, partners and administrators.</p>
        <Input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-5 h-12" />
        <Input data-testid="login-password" type="password" placeholder="Password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-3 h-12" />
        <button data-testid="login-submit-btn" disabled={busy} className="tap mt-5 h-12 w-full rounded-xl bg-slate-900 font-display font-bold uppercase tracking-wide text-white">{busy ? "Signing in…" : "Sign in"}</button>
        <Link to="/start" className="mt-4 block text-center text-sm text-slate-500" data-testid="login-back-link">Back to AskJoe-AI</Link>
      </form>
    </div>
  );
}
